import AboutUs from '../components/pages/AboutUs/AboutUs';
export default AboutUs;
